var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-checklist",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-checklist:not(.animated) .animable {opacity: 0;}svg#freepik_stories-checklist.animated #freepik--background-simple--inject-1 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-checklist.animated #freepik--Shadow--inject-1 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-checklist.animated #freepik--Checklist--inject-1 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-checklist.animated #freepik--Character--inject-1 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}            @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1",
    className: "animable",
    style: {
      transformOrigin: "239.61px 239.988px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.08,144.07c-26-23.09-64.73-32.8-98.88-29.64-17.18,1.59-31,8.71-46.66,15.06-22,8.9-36.54,5-59,2.6C106.33,125,76.23,188,75.1,235c-1.38,57.18,38.65,109.36,95,123.89,37.93,9.78,74.47,10.19,107.68-2.12,25.92-9.62,32.39-30.74,40.62-55.06,6.3-18.58,11.91-39.55,25.84-54.15,12.73-13.36,25.84-2.11,40.5-10.23C422,216.67,398,163.53,376.08,144.07Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "239.61px 239.988px"
    },
    id: "elbf18t64qnkn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4kyhoyd8urp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.08,144.07c-26-23.09-64.73-32.8-98.88-29.64-17.18,1.59-31,8.71-46.66,15.06-22,8.9-36.54,5-59,2.6C106.33,125,76.23,188,75.1,235c-1.38,57.18,38.65,109.36,95,123.89,37.93,9.78,74.47,10.19,107.68-2.12,25.92-9.62,32.39-30.74,40.62-55.06,6.3-18.58,11.91-39.55,25.84-54.15,12.73-13.36,25.84-2.11,40.5-10.23C422,216.67,398,163.53,376.08,144.07Z",
    style: {
      fill: "#9C9DA4",
      opacity: 0.9,
      transformOrigin: "239.61px 239.988px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1",
    className: "animable animator-hidden animator-active",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Checklist--inject-1",
    className: "animable",
    style: {
      transformOrigin: "209.895px 245.805px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "316.5 99.3 85.98 99.3 101.15 413.24 331.67 413.24 316.5 99.3",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "208.825px 256.27px"
    },
    id: "elnz01g0q0co",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxt77b7vv76j"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "316.5 99.3 85.98 99.3 101.15 413.24 331.67 413.24 316.5 99.3",
    style: {
      opacity: 0.2,
      transformOrigin: "208.825px 256.27px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "318.63 99.3 88.11 99.3 103.29 413.24 333.81 413.24 318.63 99.3",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "210.96px 256.27px"
    },
    id: "elimoujgs0w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elyblf7cwv12k"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "306.46 109.86 98.65 109.86 113.17 399.05 293.87 398.81 323.9 372.19 306.46 109.86",
    style: {
      opacity: 0.2,
      transformOrigin: "211.275px 254.455px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.05,109.85A2354.69,2354.69,0,0,0,329,368.71q-24.7,17-49.15,34H124.43A2360.67,2360.67,0,0,1,98.65,109.85Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "213.825px 256.28px"
    },
    id: "elcc078vrc0x5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,368.71q-24.7,17-49.15,34,5.34-22.5,11.13-45Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "304.425px 380.21px"
    },
    id: "elbau92wk56il",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,136.31q.59,15.88,1.38,31.78H124.61q-.8-15.9-1.38-31.78H155m3.24-3.35H119.76q.67,19.23,1.67,38.48h38.49q-1-19.24-1.67-38.48Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "139.84px 152.2px"
    },
    id: "el1hm1rzjs9ec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.82,148.24H176c-.1-2.39-.19-4.79-.28-7.18H284.53C284.62,143.45,284.72,145.85,284.82,148.24Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "230.27px 144.65px"
    },
    id: "elzso2t8krb6b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.83,163.34H176.67c-.11-2.4-.23-4.79-.33-7.18h85.15Q261.66,159.75,261.83,163.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "219.085px 159.75px"
    },
    id: "elwnmaghgntu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.12,198.55q1,15.9,2.23,31.8H128.57q-1.23-15.9-2.23-31.8h31.78m3.14-3.35H122.78q1.18,19.25,2.69,38.5H164q-1.5-19.24-2.7-38.5Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "143.39px 214.45px"
    },
    id: "elv5m698ldh5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.4,210.49h-40c-.16-2.4-.33-4.79-.48-7.19h40C219.07,205.7,219.23,208.09,219.4,210.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "199.16px 206.895px"
    },
    id: "elqip3m5a32ve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.27,210.49H227.86c-.16-2.4-.33-4.79-.48-7.19h29.41C256.94,205.7,257.1,208.09,257.27,210.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "242.325px 206.895px"
    },
    id: "elw98p4ftxu3i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.73,225.6H180.5c-.18-2.4-.35-4.79-.53-7.19H275.2C275.38,220.81,275.55,223.2,275.73,225.6Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "227.85px 222.005px"
    },
    id: "elfe9xfwgz1eo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.89,260.82q1.43,15.9,3.08,31.8H134.19q-1.65-15.9-3.08-31.8h31.78m3.06-3.35H127.46q1.7,19.26,3.72,38.51h38.49q-2-19.26-3.72-38.51Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "148.565px 276.725px"
    },
    id: "elh1szszigb3m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.1,280.69H185.27l.72,7.18H294.82Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "240.045px 284.28px"
    },
    id: "elrkzdmtijy8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,265.58H183.84c.22,2.39.44,4.79.67,7.18h85.15C269.44,270.37,269.21,268,269,265.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "226.75px 269.17px"
    },
    id: "elki7ahimwlqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.32,323.09q1.86,15.9,3.93,31.79H141.47q-2.07-15.88-3.93-31.79h31.78m3-3.35H133.8Q136,339,138.55,358.23H177q-2.53-19.23-4.75-38.49Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "155.4px 338.985px"
    },
    id: "eluexz0r8ih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.09,335H191.26c-.29-2.4-.58-4.79-.86-7.19H299.22C299.51,330.24,299.79,332.63,300.09,335Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "245.245px 331.405px"
    },
    id: "elti37ekison",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.69,350.13H193.15c-.31-2.39-.61-4.79-.91-7.18h49.54C242.08,345.34,242.38,347.74,242.69,350.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "217.465px 346.54px"
    },
    id: "el78vxlacse7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.27,350.13H250.88c-.31-2.39-.61-4.79-.91-7.18h21.39C271.66,345.34,272,347.74,272.27,350.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "261.12px 346.54px"
    },
    id: "eluzqmk1okuto",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,163.55l-1.41-2.24c-3.08-4.9-9.36-9.27-11.53-10.55l1.62-2.87a45.5,45.5,0,0,1,11.26,9.67c4.84-6.59,12-13.4,21.8-20.72l2.07,2.7c-10.46,7.83-17.78,15-22.4,21.9Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "146.435px 150.195px"
    },
    id: "elqpuitohcxe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.8,225.81l-1.47-2.24c-3.2-4.9-9.6-9.28-11.8-10.56l1.53-2.87a47,47,0,0,1,11.53,9.68c4.66-6.6,11.63-13.41,21.24-20.74.71.9,1.43,1.8,2.14,2.71-10.25,7.84-17.38,15-21.81,21.91C145.7,224.4,145.25,225.11,144.8,225.81Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "149.75px 212.445px"
    },
    id: "elj8peqa3z0bo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.32,288.24,148.79,286c-3.34-4.9-9.86-9.28-12.09-10.55.48-1,1-1.92,1.46-2.87a49.09,49.09,0,0,1,11.78,9.67c4.49-6.6,11.28-13.4,20.68-20.74l2.22,2.71c-10,7.84-17,15-21.23,21.91Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "154.77px 274.875px"
    },
    id: "elhabaps2zwir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.13,385.46c-5.9,0-9.3-2.18-12.3-4.1s-5.58-3.58-10.56-3.58-7.2,1.74-9.55,3.58-5.23,4.1-11.13,4.1-9.3-2.18-12.29-4.1-5.57-3.58-10.56-3.58-7.2,1.74-9.55,3.58-5.23,4.1-11.12,4.1-9.3-2.18-12.3-4.1-5.57-3.58-10.56-3.58c-.13-1-.27-1.92-.4-2.88,5.9,0,9.29,2.18,12.29,4.1s5.57,3.58,10.55,3.58,7.2-1.74,9.55-3.58,5.24-4.1,11.14-4.1,9.28,2.18,12.28,4.1,5.58,3.58,10.56,3.58,7.2-1.74,9.55-3.58,5.24-4.1,11.14-4.1,9.29,2.18,12.29,4.1,5.57,3.58,10.56,3.58C250.85,383.54,251,384.5,251.13,385.46Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "195.97px 380.18px"
    },
    id: "elt2q72uo2t5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.59,107.07c-3.38-9-11.19-14.91-19.59-14.91H222.88a6.51,6.51,0,0,1-5.95-4,16,16,0,0,0-14.57-9.79,14.17,14.17,0,0,0-13.62,9.79,5.78,5.78,0,0,1-5.57,4H166.06c-8.41,0-15.65,5.94-18.15,14.91l-1,3.57h114Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "203.91px 94.5046px"
    },
    id: "el0ym54yeujqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.2,114.16H148a3.74,3.74,0,0,1-3.69-3.52h0a3.33,3.33,0,0,1,3.35-3.51H259.86a3.74,3.74,0,0,1,3.69,3.51h0A3.33,3.33,0,0,1,260.2,114.16Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "203.93px 110.645px"
    },
    id: "elwhbsh4scmd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elx89fmbd1e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.2,114.16H148a3.74,3.74,0,0,1-3.69-3.52h0a3.33,3.33,0,0,1,3.35-3.51H259.86a3.74,3.74,0,0,1,3.69,3.51h0A3.33,3.33,0,0,1,260.2,114.16Z",
    style: {
      opacity: 0.2,
      transformOrigin: "203.93px 110.645px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1",
    className: "animable",
    style: {
      transformOrigin: "341.25px 268.02px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "360.92 410.23 353.59 410.23 352.86 393.26 360.19 393.26 360.92 410.23",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "356.89px 401.745px"
    },
    id: "elhafn48srqv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.91 410.23 397.58 410.23 393.9 393.26 401.22 393.26 404.91 410.23",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "399.405px 401.745px"
    },
    id: "elb50b4vqcqum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.06,409.38h8.23a.63.63,0,0,1,.62.5l1.45,6.52a1.08,1.08,0,0,1-1.07,1.3c-2.87-.05-4.27-.22-7.89-.22-2.23,0-6.82.23-9.89.23s-3.48-3-2.22-3.31c5.65-1.24,7.77-2.94,9.58-4.57A1.8,1.8,0,0,1,397.06,409.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "396.503px 413.545px"
    },
    id: "elrdcw4aibq8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.64,409.38h8a.63.63,0,0,1,.62.5l1.45,6.52a1.06,1.06,0,0,1-1,1.3c-2.89-.05-7.06-.22-10.69-.22-4.24,0-7.9.23-12.88.23-3,0-3.84-3-2.58-3.31,5.73-1.26,10.41-1.39,15.36-4.45A3.44,3.44,0,0,1,353.64,409.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "349.866px 413.545px"
    },
    id: "eluzkjbp3lryl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,142.92c-1,5.36-1.58,12,2.17,15.58,0,0-2.15,5.44-12.11,5.44-9.1,0-4.54-5.44-4.54-5.44,6-1.43,5.66-8.82,4.62-13Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "361.274px 153.43px"
    },
    id: "elfbt5a973enm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.66,159.25c.2-1.33,2.54-2.88,5.2-3.46s12.88-1.87,16-.58-.54,5.11-.54,5.11Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "361.89px 157.488px"
    },
    id: "els3gnz6pawx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elor1evmpzg1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.66,159.25c.2-1.33,2.54-2.88,5.2-3.46s12.88-1.87,16-.58-.54,5.11-.54,5.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "361.89px 157.488px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elpla5m6902ur"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "352.86 393.27 353.24 402.01 360.57 402.01 360.19 393.27 352.86 393.27",
    style: {
      opacity: 0.2,
      transformOrigin: "356.715px 397.64px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnn72ycp2xq"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "401.23 393.27 393.9 393.27 395.8 402.01 403.13 402.01 401.23 393.27",
    style: {
      opacity: 0.2,
      transformOrigin: "398.515px 397.64px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.35,165.1,376.52,171s12.68,22.55,11.62,26.16c-1.45,4.92-3.47,15.67-6.22,21.13.36,1.18,2.19,3.87,3.21,4.33,7-5.32,14.07-22,13.81-26.67C398.33,185.36,385.35,165.1,385.35,165.1Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "387.733px 193.86px"
    },
    id: "elszefc0qep7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.92,218.31l-7-.54,3.67,7.71s6.11.27,7.13-4.4Z",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "380.32px 221.626px"
    },
    id: "elh4ornl9lzdq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.52 255.91 415.93 257.02 411.97 264.51 271.39 190.18 275.93 181.58 416.52 255.91",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "343.955px 223.045px"
    },
    id: "el6f8wxwnytu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.61 238.74 422.71 244.22 421.07 247.32 280.48 172.99 285.02 164.39 425.61 238.74",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "353.045px 205.855px"
    },
    id: "el3ttlbj2ekz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1edo39we6qo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.64,
    y: 134.94,
    width: 9.72,
    height: 159.03,
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "348.5px 214.455px",
      transform: "rotate(-62.09deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4n39a4ocpns"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.64,
    y: 134.94,
    width: 9.72,
    height: 159.03,
    style: {
      opacity: 0.2,
      transformOrigin: "348.5px 214.455px",
      transform: "rotate(-62.09deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.33 165.53 261.24 173.27 271.39 190.18 285.02 164.4 265.33 165.53",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "273.13px 177.29px"
    },
    id: "el1mqthvy0ll7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgg2biegj989"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "265.33 165.53 261.24 173.27 271.39 190.18 285.02 164.4 265.33 165.53",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "273.13px 177.29px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "256.89 166.02 261.24 173.27 265.33 165.53 256.89 166.02",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "261.11px 169.4px"
    },
    id: "el3l8pspay3l8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.29 221.28 372.95 228.1 378.62 225.48 374.95 217.77 369.29 221.28",
    style: {
      fill: "rgb(181, 91, 82)",
      transformOrigin: "373.955px 222.935px"
    },
    id: "eli4061f55ec8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.25,160.16c6.93,1,14.87,25,14.87,25l-14.56,8.22S377.15,182,374,173.5C370.68,164.61,375.82,159.08,383.25,160.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "385.545px 176.703px"
    },
    id: "elmqp4h7u4buo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrdocyhgqh4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.22,168.39c-3.15-2.88-1.22,9.45.28,17.34.77,1.54,1.5,2.94,2.12,4.11C385.13,183.64,383.56,172.36,379.22,168.39Z",
    style: {
      opacity: 0.2,
      transformOrigin: "380.537px 178.901px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.21,160.54s-8.65,22.12-.44,63.32H381c.27-6-3.51-35.36,2.29-63.7a102,102,0,0,0-13.12-1.66,144.4,144.4,0,0,0-16.65,0A73,73,0,0,0,342.21,160.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.761px 191.06px"
    },
    id: "elmnfo3h2j9vj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.24,170.82l-9.88-3.91s-11.38,23.23-15,24.4c-4.87,1.6-14.87,6-20.93,6.86-.76,1-1.94,4-1.75,5.1,8.35,2.73,26.12-.89,29.8-3.75C338.92,193,348.24,170.82,348.24,170.82Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "324.45px 185.574px"
    },
    id: "elrz2p768u0r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2xhdodkjuh2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.35,168.18c-1.63-3.76-4.75-5.33-8-4.78-1.26,4.61-3.39,14.74-3,30l2.33,1.12S352.14,174.61,349.35,168.18Z",
    style: {
      opacity: 0.2,
      transformOrigin: "344.045px 178.907px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.91,165.55c2.46,6.56-10,25.86-10,25.86l-14.66-8a89.48,89.48,0,0,1,8.47-17.15C339.87,158.57,348.2,158.36,350.91,165.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "338.741px 175.865px"
    },
    id: "el3m9vs9b1fj1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.79,198.15,294.07,200l4.42,8.07a24.13,24.13,0,0,0,6.55-4.78Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "299.555px 203.11px"
    },
    id: "elwwzipjip9na",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.95 201.83 293.43 206.65 298.49 208.11 294.07 200.04 289.95 201.83",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "294.22px 204.075px"
    },
    id: "elu1u9sccwkg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.38,135.21c0,.59-.37,1-.76,1s-.67-.52-.63-1.11.37-1,.76-1S351.42,134.62,351.38,135.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "350.685px 135.155px"
    },
    id: "elrt749w4j39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.9,135.26a21.08,21.08,0,0,1-3.11,4.88,3.39,3.39,0,0,0,2.79.69Z",
    style: {
      fill: "rgb(237, 132, 126)",
      transformOrigin: "350.345px 138.077px"
    },
    id: "elto0ehsisf3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.63,133.17a.47.47,0,0,1-.15-.06.34.34,0,0,1-.1-.48,3.48,3.48,0,0,1,2.71-1.64.37.37,0,0,1,.35.35.35.35,0,0,1-.35.35h0A2.74,2.74,0,0,0,351,133,.35.35,0,0,1,350.63,133.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "351.88px 132.083px"
    },
    id: "elx1zrfzoj8ms",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.26,134.7c-.86,7.22-1,11.48-4.87,15-5.83,5.28-14.58,1.45-15.9-5.89-1.18-6.6.43-17.29,7.69-19.77A9.92,9.92,0,0,1,371.26,134.7Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "360.741px 137.824px"
    },
    id: "eldwzdrsi17yq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.71,136.11c-2.53.5-6.57-5.12-3.27-9.89-1.67-.83-7.12,2.45-9.17-.61s3.64-4.69,2.55-7.28c3.86.79-2.5,5.61,1.17,5.14s7.9-7.25,12-4.47c7.25,4.87,17.13-3.25,13.1,6.92,4.94-1,8.32,4.84,3.61,8.89-9.39,8.05-3.61,9.11-9.56,9.52C364.16,144.55,357.23,141,356.71,136.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "361.388px 131.335px"
    },
    id: "elbfevjko9v8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.46,138a6,6,0,0,1-3.49,3.09c-2,.69-3.15-1.1-2.68-3.07.42-1.78,2-4.28,4.07-4.1A2.73,2.73,0,0,1,360.46,138Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "357.505px 137.576px"
    },
    id: "elzvzv3v4efij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.67,223.86s8.32,56,12.88,77c5,23,23.83,99.49,23.83,99.49H405.8s-12.41-74.66-15.27-97.41c-3.09-24.68-9.57-79.05-9.57-79.05Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "380.735px 312.105px"
    },
    id: "elwyzyitxg5m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnuorbd8xj4g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.67,223.86s8.32,56,12.88,77c5,23,23.83,99.49,23.83,99.49H405.8s-12.41-74.66-15.27-97.41c-3.09-24.68-9.57-79.05-9.57-79.05Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "380.735px 312.105px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfytvhfxbks"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.55,243.44c-.62-.88-1.18-1.18-1.7-1l-.11,0a1.46,1.46,0,0,0-.33.2,2,2,0,0,0-.29.29l-.16.2-.21.33a6.43,6.43,0,0,0-.45.91c-.08.19-.16.39-.23.59s-.18.51-.26.79-.23.76-.34,1.17c0,.11-.05.21-.08.32s-.11.46-.16.69-.09.4-.13.6c-.09.39-.17.8-.25,1.22s-.17.91-.25,1.38c0,.16-.05.32-.08.49-.1.6-.19,1.21-.28,1.84h0c2.22,13.94,4.86,29.92,7,41.07.1-.36.21-.74.3-1.15a52,52,0,0,0,1-5.64C370.43,273.37,369.56,249.17,365.55,243.44Z",
    style: {
      opacity: 0.2,
      transformOrigin: "364.868px 268.46px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.77,223.86s-1,54.78-.21,77.13c.83,23.24,8.95,99.33,8.95,99.33h12.41s.45-74.74,1-97.56c.6-24.88,3.6-78.9,3.6-78.9Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "354.388px 312.09px"
    },
    id: "elhmitffy51k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwqwc7gmbsx8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.77,223.86s-1,54.78-.21,77.13c.83,23.24,8.95,99.33,8.95,99.33h12.41s.45-74.74,1-97.56c.6-24.88,3.6-78.9,3.6-78.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "354.388px 312.09px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M363.74,396.52c.05,0,0,4.05,0,4.05H349.43l-.6-4.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "356.296px 398.295px"
    },
    id: "elt6fgba2thur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.8,396.82c.06,0,.67,3.75.67,3.75H391.72l-1.3-4.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "398.445px 398.42px"
    },
    id: "eljwq66ycvixm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.64,410.66a2.2,2.2,0,0,1-1.41-.37,1,1,0,0,1-.36-.92.57.57,0,0,1,.29-.49c.81-.41,3.18,1,3.45,1.2a.18.18,0,0,1,.07.18.17.17,0,0,1-.13.14A8.82,8.82,0,0,1,394.64,410.66Zm-1.09-1.51a.53.53,0,0,0-.23,0,.22.22,0,0,0-.11.2.71.71,0,0,0,.24.63,3.5,3.5,0,0,0,2.6.14A7,7,0,0,0,393.55,409.15Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "394.772px 409.736px"
    },
    id: "el0t4h86xs6qs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.51,410.41a.13.13,0,0,1-.08,0c-.76-.41-2.22-2-2.07-2.83a.56.56,0,0,1,.55-.45.91.91,0,0,1,.74.22c.85.69,1,2.81,1,2.9a.21.21,0,0,1-.08.16A.17.17,0,0,1,396.51,410.41Zm-1.48-3H395c-.23,0-.25.13-.26.18-.09.48.84,1.69,1.6,2.26a4.14,4.14,0,0,0-.87-2.29A.57.57,0,0,0,395,407.43Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "395.5px 408.768px"
    },
    id: "elyllemb5w54a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.59,410.66a2.75,2.75,0,0,1-1.78-.45,1,1,0,0,1-.32-.84.52.52,0,0,1,.28-.46c.89-.5,3.84,1,4.17,1.17a.16.16,0,0,1,.09.18.16.16,0,0,1-.14.14A11.86,11.86,0,0,1,350.59,410.66Zm-1.33-1.51a.73.73,0,0,0-.32.06.22.22,0,0,0-.11.19.61.61,0,0,0,.21.55c.45.4,1.66.47,3.28.2A9.64,9.64,0,0,0,349.26,409.15Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "350.759px 409.74px"
    },
    id: "el9lrcjsyxafh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.86,410.41l-.07,0c-.89-.4-2.64-2-2.5-2.81,0-.19.17-.44.64-.48a1.25,1.25,0,0,1,1,.29c.93.77,1.12,2.74,1.13,2.83a.15.15,0,0,1-.07.15A.18.18,0,0,1,352.86,410.41Zm-1.79-3H351c-.31,0-.33.15-.34.2-.08.49,1.11,1.74,2,2.28a4,4,0,0,0-1-2.26A1,1,0,0,0,351.07,407.43Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "351.672px 408.76px"
    },
    id: "elbyo8iae6pp",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.b2a3e0726114fb3d48d7d13fb746a5e3.svg";
export { ForwardRef as ReactComponent };